import {
  type ToastOptions,
  type ToastPromiseParams,
  toast,
} from "react-toastify";

import { ErrorToast } from "./error-toast";
import type { ErrorData } from "./types";

export const notifyError = (
  message: string,
  _description?: string,
  options?: ToastOptions<ErrorData>
) => {
  return toast.error(<ErrorToast message={message} />, options);
};

export const notifySuccess = (message: string, options?: ToastOptions) => {
  return toast.success(message, options);
};

export const notifyPromise = <T,>(
  promise: Promise<T>,
  promiseParams: ToastPromiseParams<T>,
  options?: ToastOptions<T>
) => {
  return toast.promise<T>(promise, promiseParams, options);
};

export const notify = (message: string, options?: ToastOptions) => {
  return toast(message, options);
};
